import { render, staticRenderFns } from "./dSocialNetsPie.vue?vue&type=template&id=363f6c6e&"
import script from "./dSocialNetsPie.vue?vue&type=script&lang=js&"
export * from "./dSocialNetsPie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports